export const mmseConfig = [
  {
    name: 'year',
    options: ['correct'],
    description: false,
  },
  {
    name: 'season',
    options: ['correct'],
    description: true,
  },
  {
    name: 'dayOfMonth',
    options: ['correct'],
    description: false,
  },
  {
    name: 'dayOfWeek',
    options: ['correct'],
    description: false,
  },
  {
    name: 'month',
    options: ['correct'],
    description: false,
  },
  {
    name: 'country',
    options: ['correct'],
    description: false,
  },
  {
    name: 'region',
    options: ['correct'],
    description: false,
  },
  {
    name: 'city',
    options: ['correct'],
    description: false,
  },
  {
    name: 'place',
    options: ['correct'],
    description: true,
  },
  {
    name: 'floor',
    options: ['correct'],
    description: false,
  },
  {
    name: 'words1',
    options: ['first', 'second', 'third'],
    description: true,
  },
  {
    name: 'subtraction',
    options: ['93', '86', '79', '72', '65'],
    description: true,
  },
  {
    name: 'words2',
    options: ['first', 'second', 'third'],
    description: true,
  },
  {
    name: 'items',
    options: ['a', 'b'],
    description: false,
  },
  {
    name: 'repeatSentence',
    options: ['correct'],
    description: true,
  },
  {
    name: 'paper',
    options: ['paperInLeftHand', 'foldsIt', 'setsItOnKnees'],
    description: true,
  },
  {
    name: 'text',
    options: ['correct'],
    description: true,
  },
  {
    name: 'writeSentence',
    options: ['correct'],
    description: true,
  },
  {
    name: 'draw',
    options: ['correct'],
    description: true,
  },
];
